<template lang="pug">
.container.grid-lg.py-2
  loading.v-loading(:loading="loading")
  form(@submit.prevent="save")
    .card
      .card-body(v-if="params")
        form-group(
          label="Meta de ponstos mínimo individual",
          :validation="$v.params.meta_minimo_individual"
        )
          div
            money.form-input(
              v-model.number="$v.params.meta_minimo_individual.$model"
            )
            .text-small
              i Quantidade mínima de pontos para ter acesso a produtividade.
        form-group(
          label="Máximo de pontos individual",
          :validation="$v.params.maximo_individual"
        )
          div
            money.form-input(
              v-model.number="$v.params.maximo_individual.$model"
            )
            .text-small
              i Quantidade máxima de pontos da meta individual, acima disso vai para extraordinária.
        form-group(
          label="Meta coletiva",
          :validation="$v.params.meta_coletiva"
        )
          div
            money.form-input(v-model.number="$v.params.meta_coletiva.$model")
            .text-small
              i Pontuação mínima para que todos alcancem para ter os pontos coletivos.
        form-group(
          label="Quantidade de pontos se cumprida a meta coletiva",
          :validation="$v.params.pontos_cumprida_meta_coletiva"
        )
          div
            money.form-input(
              v-model.number="$v.params.pontos_cumprida_meta_coletiva.$model"
            )
            .text-small
              i Quantidade de pontos que será adiciona se todos atingirem a meta mínima.
        form-group(
          label="Início da pontuação extraordinária (Super meta)",
          :validation="$v.params.pontuacao_extraordinaria_inicio"
        )
          div
            money.form-input(
              v-model.number="$v.params.pontuacao_extraordinaria_inicio.$model"
            )
            .text-small
              i Quantidade de pontos para começar a contar como pontuação por fração extraordinária (Super Meta).
        form-group(
          label="Máximo de pontos da meta extraordinária",
          :validation="$v.params.maximo_extraordinaria"
        )
          div
            money.form-input(
              v-model.number="$v.params.maximo_extraordinaria.$model"
            )
            .text-small
              i Quantidade máxima de pontos da meta extraordinária.
        form-group(
          label="Percentual máximo total individual sobre o salário base",
          :validation="$v.params.percentual_total_individual"
        )
          div
            money.form-input(
              v-model.number="$v.params.percentual_total_individual.$model"
            )
            .text-small
              i Percentual máximo da meta individual que inside sobre o salário base.
        form-group(
          label="Percentual máximo total coletivo sobre o salário base",
          :validation="$v.params.percentual_total_coletivo"
        )
          div
            money.form-input(
              v-model.number="$v.params.percentual_total_coletivo.$model"
            )
            .text-small
              i Percentual máximo da meta coletiva que inside sobre o salário base.
        form-group(
          label="Fração da meta extraordinária",
          :validation="$v.params.fracao_extraordinaria"
        )
          div
            money.form-input(
              v-model.number="$v.params.fracao_extraordinaria.$model"
            )
            .text-small
              i Fração da meta extraordinária que inside sobre o salário base.
        form-group(
          label="Percentual por fração da meta extraordinária",
          :validation="$v.params.percentual_por_fracao_extraordinaria"
        )
          div
            money.form-input(
              v-model.number="$v.params.percentual_por_fracao_extraordinaria.$model"
            )
            .text-small
              i Percentual por fração da meta extraordinária que inside sobre o salário base.
        form-group(
          label="Pontos por hora de serviços extra",
          :validation="$v.params.pontos_por_hora_servico_extra"
        )
          div
            money.form-input(
              v-model.number="$v.params.pontos_por_hora_servico_extra.$model"
            )
            .text-small
              i Participação em serviços de qualquer natureza, passível de pontuação conforme legislação vigente.
        form-group(
          label="Pontos por local fechado",
          :validation="$v.params.pontos_local_fechado"
        )
          div
            money.form-input(
              v-model.number="$v.params.pontos_local_fechado.$model"
            )
            .text-small
              i Quantidade de pontos para cada tentativa de OS-m com local fechado.
        form-group(
          label="Pontos perdidos por reabrir OS-m",
          :validation="$v.params.pontos_perdidos_ao_reabrir_osm"
        )
          div
            money.form-input(
              v-model.number="$v.params.pontos_perdidos_ao_reabrir_osm.$model"
            )
            .text-small
              i Quantidade de pontos que o usuário vai perder ao reabrir uma OS-m.
        form-group(
          label="Pontos perdidos ao concluir OS-m fora do prazo",
          :validation="$v.params.pontos_perdidos_por_dia_atraso_encerrar_osm"
        )
          div
            money.form-input(
              v-model.number="$v.params.pontos_perdidos_por_dia_atraso_encerrar_osm.$model"
            )
            .text-small
              i Quantidade de pontos que o usuário vai perder ao concluir uma OS-m fora do prazo definido.
        form-group(
          label="Quantidade de meses para experiência",
          :validation="$v.params.meses_experiencia"
        )
          div
            int.form-input(v-model.number="$v.params.meses_experiencia.$model")
            .text-small
              i Quantidade de meses para considerar a o fiscal em experiência.
        form-group(
          label="Pontos mínimos para experiência",
          :validation="$v.params.pontos_minimo_experiencia"
        )
          div
            money.form-input(
              v-model.number="$v.params.pontos_minimo_experiencia.$model"
            )
            .text-small
              i Quantidade de pontos mínimos a o fiscal em experiência.
        form-group(
          label="Quantidade de meses para calcular média no afastamento",
          :validation="$v.params.meses_calcular_media_afastamento"
        )
          div
            int.form-input(
              v-model.number="$v.params.meses_calcular_media_afastamento.$model"
            )
            .text-small
              i Quantidade de meses para considerar a média quando o usuário está afastado (férias/licença/atestado...).
        form-group(
          label="Nome do secretário",
          :validation="$v.params.secretario"
        )
          input.form-input(v-model="$v.params.secretario.$model")
        form-group(
          label="Fiscais internos",
          :validation="$v.params.usuarios_internos_ids"
        )
          fiscais-picker(v-model="$v.params.usuarios_internos_ids.$model")
        form-group(
          label="Membros da Comissão",
          :validation="$v.params.comissao"
        )
          div(v-if="params.comissao")
            .columns(v-for="(c, i) in params.comissao")
              .column
                form-group(
                  label="Nome",
                  :validation="$v.params.comissao.$each[i].nome"
                )
                  input.form-input(
                    v-model="$v.params.comissao.$each[i].nome.$model",
                    placeholder="Nome"
                  )
              .column.col-auto
                form-group(
                  label="Matricula",
                  :validation="$v.params.comissao.$each[i].matricula"
                )
                  input.form-input(v-model="c.matricula")
              .column.col-auto
                .form-group
                  label.form-label &nbsp;
                  div
                    a.btn.btn-link(@click="removeMembro(i)")
                      btn-icon.text-error(name="delete")
          .py-2
            a.btn.btn-link(@click="addNewMembro()")
              btn-content(name="new", label="Novo membro")
        form-group(
          label="Fator de Multiplicação em razão dos valores dos documentos emitidos",
          :validation="$v.params.doc_multiplicadores"
        )
          div(v-if="params.doc_multiplicadores")
            doc-multiplicadores(v-model="$v.params.doc_multiplicadores.$model")
          .py-2(v-else)
            a.btn.btn-link(@click="addNewDocMultiplicador()")
              btn-content(name="new", label="Criar regra")
      .card-footer
        .divider
        .py-2
          .columns
            .column
            .column.col-auto
              button.btn.btn-primary(
                type="submit",
                :class="{ loading: loading }",
                @click="save",
                :disabled="loading || $v.$invalid"
              )
                btn-content(name="save")
</template>

<script>
import api from "@/api/sistema/produtividadeParams"
import parseErrors from "@/lib/errors/parseErrors"
import DocMultiplicadores from "./DocMultiplicadores"
import validations from "./validations"

export default {
  data() {
    return { params: null, loading: false }
  },

  components: { DocMultiplicadores },

  methods: {
    save() {
      api
        .update(this.params)
        .then((res) => {
          this.params = res
          this.$toaster.success("Salvo com sucesso.")
        })
        .catch((e) => {
          this.$toaster.error(parseErrors(e).join(", "))
        })
    },

    addNewMembro() {
      if (!this.params.comissao) {
        this.$set(this.params, "comissao", [])
      }
      this.params.comissao.push({ nome: "", matricula: "" })
    },

    removeMembro(index) {
      this.$delete(this.params.comissao, index)
    },

    addNewDocMultiplicador() {
      if (!this.params.doc_multiplicadores) {
        this.$set(this.params, "doc_multiplicadores", [])
      }
      this.params.doc_multiplicadores.push({
        valor_inicial: 0,
        valor_final: 0,
        fator: 1,
      })
    },
  },

  validations: {
    params: validations,
  },

  async created() {
    this.loading = true
    try {
      this.params = await api.current()
    } catch (e) {
      this.$toaster.error(parseErrors(e).join(", "))
    }
    this.loading = false
  },
}
</script>
